import React, { useState } from 'react'
import { Content } from 'antd/es/layout/layout'
import PAQ from '../shop-front-component/PAQ'

import { useNavigate } from 'react-router-dom'
import { Breadcrumb, Image, Popover, Tooltip } from 'antd'
import { CFCDN, blindList, toRollerShutter } from '../shop-front-component/ProductCollection'


const colorList = [
    {
        title:'White',
        src: CFCDN+"roller-shutter-color/white.png",
        close_src : CFCDN+"roller-shutter-color/white-close.png",
    },
    {
        title:'Surfmist',
        src: CFCDN+"roller-shutter-color/surfmist.png",
        close_src : CFCDN+"roller-shutter-color/surfmist-close.png",
    },
    {
        title:'Magnolia Cream',
        src: CFCDN+"roller-shutter-color/magnolia-cream.png",
        close_src : CFCDN+"roller-shutter-color/magnolia-cream-close.png",
    },
    {
        title:'Cream',
        src: CFCDN+"roller-shutter-color/cream.png",
        close_src : CFCDN+"roller-shutter-color/cream-close.png",
    },
    {
        title:'Clear Beige',
        src: CFCDN+"roller-shutter-color/clear-beige.png",
        close_src : CFCDN+"roller-shutter-color/clear-beige-close.png",
    },
    {
        title:'Shale Grey',
        src: CFCDN+"roller-shutter-color/shale-grey.png",
        close_src : CFCDN+"roller-shutter-color/shale-gray-close.png",
    },
    {
        title:'Woodland Grey',
        src: CFCDN+"roller-shutter-color/woodland-grey.png",
        close_src : CFCDN+"roller-shutter-color/woodland-grey-close.png",
    },
    {
        title:'Monument',
        src: CFCDN+"roller-shutter-color/monument.png",
        close_src : CFCDN+"roller-shutter-color/monument-close.png",
    },
    {
        title:'Black',
        src: CFCDN+"roller-shutter-color/black.png",
        close_src : CFCDN+"roller-shutter-color/black-close.png",
    },
    {
        title:'Brown',
        src: CFCDN+"roller-shutter-color/brown.png",
        close_src : CFCDN+"roller-shutter-color/brown-close.png",
    },
]

export default function RollerShutterrPage() {
    const navigate = useNavigate()
    const [currentImage,setCurrentImage] = useState(CFCDN+"product-cover/roller-shutter-with-person.jpeg")
    const [currentColour, setCurrentColour] = useState<number>()
  return (
      <div className='hedvig-letters-sans-regular bg-white'>
            <Content className=' bg-transparent'>
                <div className='max-w-screen-2xl flex flex-row m-auto mt-10 justify-between p-2'>
                    <Breadcrumb
                        items={[
                        {
                            title: <span onClick={()=>{navigate('/')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Home</span>,
                        },
                        {
                            title: <span onClick={()=>{navigate('/products/roller-shutters')}} className=' hover:underline hover:-translate-y-1 duration-300 transition-transform '>Roller Shutters</span>,
                        },
                        {
                            title: 'Roller Shutters',
                        },
                        ]}
                    />
                </div>
                <div className='max-w-screen-2xl flex flex-col lg:flex-row m-auto justify-between gap-5 mt-5'>
                    
                    
                    
                    <div className='w:full lg:w-2/3'>
                        <div className=' sticky top-0 aspect-video overflow-hidden shadow-md  border-none bg-white rounded-2xl my-auto overflow-hidden hover:shadow-xl duration-100 transition-all '
                        >
                            <Image
                                src={currentImage}    
                                alt="Centered Image"
                                height={"100%"}
                                width={"100%"}
                                className="transform object-cover object-center"
                            /> 
                        </div>
                    </div>
                    <div className=' w:full lg:w-1/3 aspect-square flex flex-col '>
                        <span className='hedvig-letters-serif-regular text-6xl mt-10 '>
                            Roller Shutters
                        </span>
                        <span className='hedvig-letters-sans-regular text-lg text-neutral-500 mt-5 '>
                            {"Experience comfort and convenience with our advanced window roller shutters. Enjoy superior heat insulation and motorized operation for effortless control. Elevate your home's style and functionality with our premium shutters."}
                        </span>

                        <div className=' w-full mt-5'>
                            <span className='hedvig-letters-sans-regular text-xl text-black mt-5 '>Select Colour:</span>
                            <div className='flex flex-wrap gap-2 mt-3'>
                            {colorList?.map((item,index) =>{
                                return(
                                    <Tooltip key={index} placement="bottom" title={item.title}>
                                        <div
                                        
                                        style={{ width: 100, height:100 }}
                                        className={` flex flex-col items-center justify-center overflow-hidden rounded-md  bg-transparent ${(currentColour == index)?'border-solid border-blue-500' :''} shadow-none`}
                                        onClick={()=>{
                                            setCurrentImage(item.src);
                                            setCurrentColour(index)
                                        }}
                                        >
                                            <div className={`overflow-hidden relative rounded-md `} style={{ width: 100, height:100 }} >

                                                
                                                <img
                                                    style={{height:100,width:'100%'}}
                                                    className="object-center object-cover w-full h-full "
                                                    alt=""
                                                    src={item.close_src}
                                        
                                                />
                                            
                                            </div>
                                        
                                    
                                        </div>
                                </Tooltip>
                                )
                            })}
                            </div>
                        
                        </div>
                        <button className="transform text-white bg-black text-xl lg:text-2xl rounded-md border-solid border-black hover:text-black hover:bg-white transition-transform duration-300 w-fit p-2 px-5 hover:translate-x-1 mb-5 mt-20"
                            onClick={()=>{navigate('/order/create')}}
                        >Order Online Now</button>
                    </div>
                </div>
                
                <div className='flex flex-col max-w-screen-2xl m-auto items-center justify-center mt-20 mb-10'>
                    <span className='text-2xl lg:text-5xl text-center hedvig-letters-serif-regular'>
                        Need help from our expert?
                    </span>
                    <span className='text-2xl text-center hedvig-letters-sans-regular underline transition-all duration-300 hover:translate-x-1 hover:text-neutral-500 mt-3'
                        onClick={()=>{navigate('/contact')}}
                    >
                        Contact us
                    </span>
                    
                </div>
            </Content>
           
        </div>
  )
}
